import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ActivatedRouteService } from './activated-route.service';
import { PatientService } from './patient.service';

/**
 * This service is used for sharing member information context between components and services.
 */
@Injectable({
  providedIn: 'root'
})
export class MemberInformationService {
  /**
   * This service is the ONLY thing that should be emitting new values through
   * this BehaviorSubject. DO NOT emit new values for memberId from anywhere else.
   */
  memberId: BehaviorSubject<string> = new BehaviorSubject(null);

  constructor(router: Router, activatedRouteService: ActivatedRouteService, patientService: PatientService) {
    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const memberId = activatedRouteService.getRouteParam('memberId');

      if (memberId && memberId !== this.memberId.value) {
        patientService.saveMemberSearchHistory(memberId).subscribe();
      }

      this.memberId.next(memberId);
    });
  }
}
